import { render } from "./Payconiq.vue?vue&type=template&id=1aba4272&ts=true"
import script from "./Payconiq.vue?vue&type=script&lang=ts"
export * from "./Payconiq.vue?vue&type=script&lang=ts"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__